import {  ResponseTypes, sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function downloadTrialAndPermanentActivations(year = new Date().getFullYear()) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'download_trial_and_permanent_activations',
        year: year
      })
    }, ResponseTypes.file
  )
}

export function getHistoryWithTotal(filters, sort, limit = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_history_with_total',
        limit,
        sort,
        filters
      })
    }
  );
}

export function getHistoryTotal(filters) {
  return sendRequestWithAuth(
    settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_history_total',
      filters
    })
  });
}

export function getHistory(filters, sort, limit, offset = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_history',
        limit,
        offset,
        sort,
        filters
      })
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/history.js